import { sendPost } from '../http.js'
const api = {
	'videoClassIndex': '/wechat/video/index',
  'videoClassCreate': '/wechat/video/create',
  'videoClassUpdate': '/wechat/video/update',
  'videoClassCategory': '/wechat/video/getCategory',
  'videoClassProduct': '/wechat/video/product',
  'videoClassCategoryDetail': '/wechat/video/category/detail',
  'videoClassInfo': '/wechat/video/info',
  'videoClassDelisting': '/wechat/video/delisting',
  'videoClassListing': '/wechat/video/listing',
  'videoClassCancel_audit': '/wechat/video/cancel_audit',
  'getSphClassCommissionRateAPI': '/wechat/video/get_kol_rate' // 获取视频号课程推广比例
  
 
}
export default {
	videoClassIndex(params) {
	  return sendPost(api.videoClassIndex, params)
	},
  videoClassCreate(params) {
    return sendPost(api.videoClassCreate, params)
  },
  videoClassUpdate(params) {
    return sendPost(api.videoClassUpdate, params)
  },
  videoClassCategory(params) {
    return sendPost(api.videoClassCategory, params)
  },
  videoClassProduct(params) {
    return sendPost(api.videoClassProduct, params)
  },
  videoClassCategoryDetail(params) {
    return sendPost(api.videoClassCategoryDetail, params)
  },
  videoClassInfo(params) {
    return sendPost(api.videoClassInfo, params)
  },
  videoClassDelisting(params) {
    return sendPost(api.videoClassDelisting, params)
  },
  videoClassListing(params) {
    return sendPost(api.videoClassListing, params)
  },
  videoClassCancel_audit(params) {
    return sendPost(api.videoClassCancel_audit, params)
  },
  getSphClassCommissionRateAPI(params) {
    return sendPost(api.getSphClassCommissionRateAPI, params)
  },
}